module.exports = __webpack_public_path__ + "static/img/circleBackg.f765597b.png";